import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import {
	adminUsersByIdLinksReducers,
	adminUsersByIdLinksWatchers } from './links';

export const adminUsersByIdReducers = combineReducers({
	links: adminUsersByIdLinksReducers
});

export const adminUsersByIdWatchers = combineAllWatchers([
	adminUsersByIdLinksWatchers
]);
